import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { UserCheck } from 'lucide-react';
export function AudienceSection() {
  const items = ['Te han diagnosticado y quieres una base clara sin tecnicismos interminables', 'Estás en prediabetes y quieres actuar antes de que vaya a más', 'Eres cuidador/a (pareja/hijo/a/familiar) y necesitas saber qué cocinar con seguridad', 'No distingues bien tipos, síntomas o reacciones (hipoglucemia/hiperglucemia) y te preocupa "meter la pata"', 'No quieres "comida de dieta": quieres platos ricos y sostenibles'];
  return <Section background="green" className="text-white" data-id="element-12">
      <div className="max-w-4xl mx-auto" data-id="element-13">
        <div className="text-center mb-8 md:mb-12" data-id="element-14">
          <h2 className="text-2xl md:text-4xl font-bold mb-3" data-id="element-15">
            Esta guía es para ti si…
          </h2>
          <div className="h-1 w-24 bg-[#BC6C25] mx-auto rounded-full" data-id="element-16"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-1 gap-3 md:gap-6" data-id="element-17">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="flex items-center bg-white/10 backdrop-blur-sm p-3 md:p-4 rounded-xl border border-white/20 hover:bg-white/20 transition-colors" data-id="element-18">
              <div className="bg-[#BC6C25] p-1.5 md:p-2 rounded-full mr-3 md:mr-4 flex-shrink-0" data-id="element-19">
                <UserCheck className="w-5 h-5 md:w-6 md:h-6 text-white" data-id="element-20" />
              </div>
              <p className="text-base md:text-lg font-medium leading-snug" data-id="element-21">
                {item}
              </p>
            </motion.div>)}
        </div>
      </div>
    </Section>;
}